import script from "./BlogList.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogList.vue?vue&type=script&setup=true&lang=js"

import "./BlogList.vue?vue&type=style&index=0&id=41b2b39e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41b2b39e"]])

export default __exports__